export function getCalloutTitleKey(
  period: 'day' | 'week' | 'month' | 'year' | 'request' | undefined,
) {
  switch (period) {
    case 'day':
      return 'spendLimits.modal.request.preRequestCallout.titleDay';
    case 'week':
      return 'spendLimits.modal.request.preRequestCallout.titleWeek';
    case 'month':
      return 'spendLimits.modal.request.preRequestCallout.titleMonth';
    case 'year':
      return 'spendLimits.modal.request.preRequestCallout.titleYear';
    case 'request':
      return 'spendLimits.modal.request.preRequestCallout.titleRequest';
    default:
      return 'spendLimits.modal.request.preRequestCallout.titleDay';
  }
}

export function getCalloutDescriptionKey(
  period: 'day' | 'week' | 'month' | 'year' | 'request' | undefined,
) {
  switch (period) {
    case 'day':
      return 'spendLimits.modal.request.calloutWarning.descriptionDay';
    case 'week':
      return 'spendLimits.modal.request.calloutWarning.descriptionWeek';
    case 'month':
      return 'spendLimits.modal.request.calloutWarning.descriptionMonth';
    case 'year':
      return 'spendLimits.modal.request.calloutWarning.descriptionYear';
    case 'request':
      return 'spendLimits.modal.request.calloutWarning.descriptionRequest';
    default:
      return 'spendLimits.modal.request.calloutWarning.descriptionDay';
  }
}

export function getLimitTranslationKey(
  period: 'day' | 'week' | 'month' | 'year' | 'request' | undefined,
) {
  switch (period) {
    case 'day':
      return 'spendLimits.modal.request.calloutWarning.limitDay';
    case 'week':
      return 'spendLimits.modal.request.calloutWarning.limitWeek';
    case 'month':
      return 'spendLimits.modal.request.calloutWarning.limitMonth';
    case 'year':
      return 'spendLimits.modal.request.calloutWarning.limitYear';
    case 'request':
      return 'spendLimits.modal.request.calloutWarning.limitRequest';
    default:
      return 'spendLimits.modal.request.calloutWarning.limitDay';
  }
}

export function getPeriodTranslationKey(
  period: 'day' | 'week' | 'month' | 'year' | 'request' | undefined,
) {
  switch (period) {
    case 'day':
      return 'spendLimits.modal.request.calloutWarning.periodDay';
    case 'week':
      return 'spendLimits.modal.request.calloutWarning.periodWeek';
    case 'month':
      return 'spendLimits.modal.request.calloutWarning.periodMonth';
    case 'year':
      return 'spendLimits.modal.request.calloutWarning.periodYear';
    case 'request':
      return 'spendLimits.modal.request.calloutWarning.periodRequest';
    default:
      return 'spendLimits.modal.request.calloutWarning.periodDay';
  }
}
